import {Component, OnInit} from '@angular/core';
import {GlobalIntegrationService} from '../../../shared/services/globalIntegration.service';
import {AuthenticationService} from '../../../core/services/authentication.service';
import {CoreService} from '../../../core/data-services/core.service';
import {BannerNotificationsService, SpinnerService} from '../../../xform-compat';
import {TranslateService} from '@ngx-translate/core';
import {SimpleEventsEmailResource} from '../../../shared/models/resources/simpleEventsEmailResource.model';
import {CONFIG} from '../../../config';
import {SimpleEventsQueryResource} from '../../../shared/models/resources/simpleEventsQueryResource.model';
import {JqueryCommonService} from '../../../shared/services/jquery-common.service';

@Component({
  standalone: false,
    selector: 'cci-email-panel',
    templateUrl: './email-panel.component.html',
    styleUrls: ['./email-panel.component.scss']
})
export class EmailPanelComponent implements OnInit {

    public recipients = '';
    public emailSubject = '';

    private FORM_UPDATE_ANIMATION_CLASS = 'cci-form-update-animation';

    public showErrors = false;

    constructor(
        private globalIntegrationService: GlobalIntegrationService,
        private authenticationService: AuthenticationService,
        private bannerNotificationsService: BannerNotificationsService,
        private spinnerService: SpinnerService,
        private translateService: TranslateService,
        private jqueryCommonService: JqueryCommonService,
        private coreService: CoreService,
    ) {
    }

    ngOnInit() {
        this.initSavedQueryLoadEventEmitterSubscriptions();
        this.initEmailPanelRequestEventEmitterSubscriptions();
    }

    public initSavedQueryLoadEventEmitterSubscriptions() {
        this.globalIntegrationService.savedQueryLoadEventEmitter.subscribe(event => {
            const eventsQueryResource = (event as SimpleEventsEmailResource);
            this.globalIntegrationService.simpleEventsQueryResource = eventsQueryResource.eventsQueryResource;
            this.recipients = eventsQueryResource.recipients.join(',');
            this.jqueryCommonService.triggerFormUpdateAnimation('cci-email-input'.toClass(), this.FORM_UPDATE_ANIMATION_CLASS);
        });
    }

    public initEmailPanelRequestEventEmitterSubscriptions() {
        this.globalIntegrationService.emailPanelRequestEventEmitter.subscribe((event) => {
            const eventsQueryResource = (event as SimpleEventsQueryResource);
            const eventsEmailResource = new SimpleEventsEmailResource({
                recipients: this.formRecipients(),
                eventsQueryResource: eventsQueryResource,
                emailSubject: this.emailSubject,
            });
            this.globalIntegrationService.emailPanelResponseEventEmitter.next(eventsEmailResource);
        });
    }

    public email() {
        console.warn(this.recipients);
        const recipients = this.recipients.split(',');
        recipients.forEach((recipient, i) => {
            recipients[i] = recipient.trim();
        });
        if (recipients.length < 1 || this.emailSubject === null || this.emailSubject === undefined) {
            return;
        }
        const eventsEmailResource = new SimpleEventsEmailResource({
            recipients: recipients,
            eventsQueryResource: this.globalIntegrationService.simpleEventsQueryResource,
            emailSubject: this.emailSubject,
        });
        console.warn(eventsEmailResource);
        if (this.globalIntegrationService.simpleEventsQueryResource) {
            this.spinnerService.start();
            this.coreService.eventsEmail(eventsEmailResource).subscribe((result) => {
                this.spinnerService.stop();
                this.bannerNotificationsService.success('Email(s) sent.');
            }, (response) => {
                this.spinnerService.stop();
                console.error(response);
                const errorCode = (response && response.error) ? response.error.code : CONFIG.authErrorCode;
                this.bannerNotificationsService.error(this.translateService.instant(`API_ERRORS.${errorCode}`));
            });
        } else {
            this.bannerNotificationsService.error('Please select a valid search Query');
        }
    }

    public formRecipients() {
        return this.recipients.split(',');
    }
}
